import React from "react";
import "./Enchante1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Enchante10images from "../../../Media/BSD/Enchante/Enhcante10";
import Enchante12images from "../../../Media/BSD/Enchante/Enhcante12";
import Enchante15images from "../../../Media/BSD/Enchante/Enhcante15";

const imageMap = {
  Enchante10images,
  Enchante12images,
  Enchante15images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Our Home</h1>
      <h2>Cicilan Start 54 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
